import { createContext, useState } from "react";
import { useDispatch } from "react-redux";

import {
  createSurveyItemService,
  deleteSurveyItemService,
  getSurveyItemsService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";

export const surveyAdminContext = createContext({
  surveyItems: [],
  setSurveyItems: () => {},
  survey: {},
  setSurvey: () => {},
  icon: "",
  setIcon: () => {},
  description: "",
  setDescription: () => {},
  positive: null,
  setPositive: () => {},
  isShowModal: null,
  setIsShowModal: () => {},
  isShowDetailsModal: null,
  setIsShowDetailsModal: () => {},
  handleShowModal: () => {},
  handleCloseModal: () => {},
  handleShowDetailsModal: () => {},
  handleCloseDetailsModal: () => {},
  handleGetSurveyItemList: () => {},
  handleCreateSurveyItem: () => {},
  handleDeleteSurveyItem: () => {},
});

const SurveyAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [surveyItems, setSurveyItems] = useState([]);
  const [survey, setSurvey] = useState({});
  const [icon, setIcon] = useState("");
  const [description, setDescription] = useState("");
  const [positive, setPositive] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowDetailsModal, setIsShowDetailsModal] = useState(false);

  const handleResetState = () => {
    setIcon("");
    setDescription("");
    setPositive(false);
  };

  // Create Survey Modal Operations
  const handleShowModal = () => setIsShowModal(true);
  const handleCloseModal = () => {
    setIsShowModal(false);
    handleResetState();
  };

  // Details Survey Modal Operations
  const handleShowDetailsModal = (value) => {
    setIsShowDetailsModal(true);
    setSurvey(value);
  };
  const handleCloseDetailsModal = () => {
    setIsShowDetailsModal(false);
    setSurvey({});
  };

  // Handle Get Survey Item List Method
  const handleGetSurveyItemList = async (event) => {
    event?.preventDefault();
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getSurveyItemsService();
      if (status === 200) {
        setSurveyItems(data.list);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Create Survey Item Method
  const handleCreateSurveyItem = async (event) => {
    event?.preventDefault();

    const objData = {
      icon,
      description,
      positive,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await createSurveyItemService(objData);
      if (status === 200) {
        toastSuccessMessage("آیتم با موفقیت ایجاد شد");
        handleGetSurveyItemList();
        handleCloseModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Delete Survey Item Method
  const handleDeleteSurveyItem = async (id) => {
    const objData = {
      id,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deleteSurveyItemService(objData);
      if (status === 200) {
        toastSuccessMessage(`آیتم  ${id} با موفقیت حذف شد`);
        handleGetSurveyItemList();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <surveyAdminContext.Provider
      value={{
        surveyItems,
        setSurveyItems,
        survey,
        setSurvey,
        icon,
        setIcon,
        description,
        setDescription,
        positive,
        setPositive,
        isShowModal,
        setIsShowModal,
        isShowDetailsModal,
        setIsShowDetailsModal,
        handleShowDetailsModal,
        handleCloseDetailsModal,
        handleShowModal,
        handleCloseModal,
        handleGetSurveyItemList,
        handleCreateSurveyItem,
        handleDeleteSurveyItem,
      }}
    >
      {children}
    </surveyAdminContext.Provider>
  );
};

export default SurveyAdminContext;
